import { Box, CardMedia, Typography, useMediaQuery } from '@mui/material'
import React from 'react'
import Btn from '../glopal/Btn'
import WrapperCatCreated from './WrapperCatCreated'
import userIcon from './../../assets/icon/Icon awesome-user-check.png'
import catIcon from './../../assets/icon/Icon ionic-ios-book.png'
import { useTheme } from '@emotion/react'

const BlogDetails = ({ img, dateBlog, createdBy, cat, nameBlog, descBlog }) => {
    const themeM = useTheme();
    const isMobile = useMediaQuery(themeM.breakpoints.down('sm'));
    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 2 }}>
                <CardMedia
                    component={'img'}
                    src={img}
                />
                {
                    isMobile ||
                    <Box sx={{ mt: '-5%', ml: '2%' }} >
                        <Btn text={dateBlog} />
                    </Box>
                }
                <Box sx={{ display: 'flex', flexDirection: { md: 'column', xs: 'column-reverse' }, gap:2, alignItems:{md:'unset', xs:'center'} }} >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }} >
                        <WrapperCatCreated icon={userIcon} text={createdBy} />
                        <WrapperCatCreated icon={catIcon} text={cat} />
                    </Box>
                    <Typography variant='h6' color={'secondary.main'} >{nameBlog}</Typography>
                </Box>
                {descBlog && descBlog?.split('.')?.map((part, index) => (
                    <Typography key={index} color={'secondary.supMain'} >{part}</Typography>
                ))}
            </Box>
        </>
    )
}

export default BlogDetails